module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.poorInfo.length > 0) ? _c('div', {
    staticClass: "poor-tag",
    on: {
      "click": _vm.showPoorInfo
    }
  }, [_c('i', {
    staticClass: "poor-tag-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "poor-tag-text"
  }, [_vm._v("扶贫")])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-c815f5d2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c815f5d2"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/poorTag.vue
// module id = 1081
// module chunks = 1